import { request } from '../../libs/http/http';

/**
 * Listar todas las actividades con filtros opcionales
 * @param {Object} filtros - { vencimiento, equipo, proveedor, fechaDesde, fechaHasta, estado }
 * @returns {Promise}
 */
export const listarActividadesConFiltros = (filtros = {}) => {
  const params = new URLSearchParams();

  if (filtros.vencimiento) params.append('vencimiento', filtros.vencimiento);
  if (filtros.equipo) params.append('equipo', filtros.equipo);
  // El backend acepta tanto 'proveedorRef' (nombre canónico) como 'proveedor'
  // (alias); enviamos el canónico.
  if (filtros.proveedor) params.append('proveedorRef', filtros.proveedor);
  if (filtros.proveedorRef) params.append('proveedorRef', filtros.proveedorRef);
  if (filtros.fechaDesde) params.append('fechaDesde', filtros.fechaDesde);
  if (filtros.fechaHasta) params.append('fechaHasta', filtros.fechaHasta);
  if (filtros.estado) params.append('estado', filtros.estado);
  if (filtros.tipoActividad) params.append('tipoActividad', filtros.tipoActividad);
  if (filtros.responsable) params.append('responsable', filtros.responsable);
  // 'cliente' no es un campo del modelo Actividad — se ignora.

  const queryString = params.toString();
  return request('get', `/Actividad/filtros${queryString ? '?' + queryString : ''}`);
};

/**
 * Devuelve los valores distintos de tipoActividad existentes en la BD.
 * Para alimentar el dropdown del filtro (los tipos se definen al crear la
 * actividad, no es un enum fijo).
 */
export const obtenerTiposActividad = () => {
  return request('get', '/Actividad/tipos');
};

/**
 * Obtener una actividad por ID
 * @param {string} id - ID de la actividad
 * @returns {Promise}
 */
export const obtenerActividadPorId = (id) => {
  return request('get', `/Actividad/${id}`);
};

/**
 * Actualizar actividad CON registro de historial
 * @param {string} id - ID de la actividad
 * @param {Object} data - Datos a actualizar (debe incluir razonCambio)
 * @returns {Promise}
 */
export const actualizarActividadConHistorial = (id, data) => {
  return request('put', `/Actividad/actualizar/${id}`, data);
};

/**
 * Obtener historial de cambios de una actividad
 * @param {string} id - ID de la actividad
 * @returns {Promise}
 */
export const obtenerHistorialActividad = (id) => {
  return request('get', `/Actividad/${id}/historial`);
};

/**
 * Actualizar actividad (endpoint legacy, sin historial)
 * @param {string} id - ID de la actividad
 * @param {Object} data - Datos a actualizar
 * @returns {Promise}
 */
export const actualizarActividad = (id, data) => {
  return request('patch', `/Actividad/${id}`, data);
};

/**
 * Cambiar múltiples actividades a estado "Requerida" y asociarlas a una requisición
 * @param {Array} actividadIds - Array de IDs de actividades
 * @param {string} requisicionId - ID de la requisición asociada
 * @returns {Promise}
 */
export const marcarActividadesComoRequeridas = (actividadIds, requisicionId) => {
  return request('patch', '/Actividad/marcar-requeridas', {
    actividadIds,
    requisicionId
  });
};
